/* global axios */
import ApiClient from './ApiClient';

// Full-CRUD service-catalog API for tramite types (the configurable "BusinessService") and their
// nested ordered stages. The index/show endpoints power both the create modal's type picker and the
// settings catalog editor. Stages are a nested sub-resource: /tramite_types/:typeId/stages.
class TramiteTypesAPI extends ApiClient {
  constructor() {
    super('tramite_types', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { tramite_type: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { tramite_type: data });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // --- Nested stages sub-resource ---
  getStages(typeId) {
    return axios.get(`${this.url}/${typeId}/stages`);
  }

  createStage(typeId, data) {
    return axios.post(`${this.url}/${typeId}/stages`, { stage: data });
  }

  updateStage(typeId, stageId, data) {
    return axios.patch(`${this.url}/${typeId}/stages/${stageId}`, {
      stage: data,
    });
  }

  deleteStage(typeId, stageId) {
    return axios.delete(`${this.url}/${typeId}/stages/${stageId}`);
  }

  reorderStages(typeId, ids) {
    return axios.patch(`${this.url}/${typeId}/stages/reorder`, { ids });
  }

  // --- Nested forms sub-resource ---
  getForms(typeId) {
    return axios.get(`${this.url}/${typeId}/forms`);
  }

  createForm(typeId, data) {
    return axios.post(`${this.url}/${typeId}/forms`, { form: data });
  }

  updateForm(typeId, formId, data) {
    return axios.patch(`${this.url}/${typeId}/forms/${formId}`, { form: data });
  }

  deleteForm(typeId, formId) {
    return axios.delete(`${this.url}/${typeId}/forms/${formId}`);
  }

  reorderForms(typeId, ids) {
    return axios.patch(`${this.url}/${typeId}/forms/reorder`, { ids });
  }
}

export default new TramiteTypesAPI();
